/**
 * Maandelijkse herberekening van de Web Vitals-samenvatting.
 *
 * Bedoeld voor een pg_cron-job (bv. dagelijks): de huidige maand wordt
 * doorlopend herberekend, de vorige maand nog één keer afgesloten.
 * De ruwe metingen blijven onbeperkt bewaard; hier wordt niets verwijderd.
 * Beveiligd met het secret uit `public.cron_secrets` (naam 'wpc-cron').
 */
import { createFileRoute } from "@tanstack/react-router";
import { rebuildMonthlySummary } from "@/lib/vitals-rollup.server";
import { getCronSecret } from "@/lib/cron-secrets.server";

async function run(request: Request) {
  const secret = await getCronSecret("wpc-cron");
  if (secret) {
    const provided =
      request.headers.get("x-cron-secret") ??
      request.headers.get("authorization")?.replace("Bearer ", "") ??
      "";
    if (provided !== secret) return new Response("Unauthorized", { status: 401 });
  }
  try {
    const result = await rebuildMonthlySummary(2);
    return Response.json(result);
  } catch (error) {
    console.error("[vitals-rollup]", (error as Error).message);
    return Response.json({ ok: false, error: "rollup mislukt" }, { status: 500 });
  }
}

export const Route = createFileRoute("/api/public/vitals-rollup")({
  staticData: { sitemap: false },
  server: {
    handlers: {
      GET: async ({ request }) => run(request),
      POST: async ({ request }) => run(request),
    },
  },
});
